import styled from 'styled-components';

import STANDARDDEFAULTSRC from 'assets/logo-tsl.svg';
import buildLogo from 'components/b2b/Logo';
import type ColormapInterface from 'shared-types/colormapinterface';
import {
  borderRadius,
  colorFilterUsage,
  fontSize,
  fontWeight,
  getSpacing,
  letterSpacing,
  lineHeight,
} from 'stylesheetB2b';
import { STANDARDLOGOKEY, getLogoModel, ALLEXTENSIONS } from 'types/logo/logo';

const logoModel = getLogoModel(STANDARDLOGOKEY, ALLEXTENSIONS, STANDARDDEFAULTSRC);

const TslLogo = buildLogo(logoModel);

const CLOSE_ICON_SPACING = getSpacing(10);

interface Props {
  $on: boolean;
}

const ACTION_WRAPPER_Z_INDEX = 1299;

export const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;
PageContainer.displayName = 'PageContainer';

export const MessageBlock = styled.div<{ colors: ColormapInterface }>`
  width: ${getSpacing(177)};
  height: ${getSpacing(100)};
  border: solid ${getSpacing(0.2)} ${({ colors }) => colors.messageBlockBorder};
  border-radius: ${borderRadius.XXLarge};
  background-color: ${({ colors }) => colors.messageBlockBackground};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: ${getSpacing(29)} ${getSpacing(12)};
  letter-spacing: ${letterSpacing.normal};
  text-align: center;
  font-size: ${fontSize.XXXLarge};
  line-height: ${lineHeight.XXLarge};
  margin-top: ${getSpacing(22)};
`;
MessageBlock.displayName = 'MessageBlock';

export const PrimaryMessage = styled.span`
  text-transform: uppercase;
  font-weight: ${fontWeight.bold};
`;
PrimaryMessage.displayName = 'PrimaryMessage';

export const SecondaryMessage = styled.span`
  font-weight: ${fontWeight.light};
`;
SecondaryMessage.displayName = 'SecondaryMessage';

export const Close = styled.div`
  position: absolute;
  top: ${CLOSE_ICON_SPACING};
  right: ${CLOSE_ICON_SPACING};
  font-size: ${getSpacing(11)};
  display: ${(props: Props) => (props.$on ? 'flex' : 'none')};
`;
Close.displayName = 'Close';

export const TslLogoComponent = styled(TslLogo)`
  flex-shrink: 0;
  width: ${getSpacing(37)};
  filter: ${colorFilterUsage.tslLogo};
  margin-bottom: ${getSpacing(5)};
`;
TslLogoComponent.displayName = 'TslLogo';

export const ActionWrapper = styled.div<{
  $on: boolean;
  colors: ColormapInterface;
}>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  z-index: ${ACTION_WRAPPER_Z_INDEX};
  cursor: pointer;
  background-color: ${({ colors }) => colors.appBackground};
  display: ${({ $on }) => ($on ? 'block' : 'none')};
`;
ActionWrapper.displayName = 'ActionWrapper';
